import React, { useEffect, useState } from "react";
import { Button, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import NodeParentChanger from "../NodeParentChanger";
import ScenarioSide from "./scenario-side";
import DeleteButton from "../DeleteButton";
import ScenarioHeader from "../ScenarioHeader";
import { MacBotActionKind } from "../types";
import { useAppSelector } from "../../../../app/hook";
import {
  loginSUM,
  logoutSUM,
  selectSUMEntityIdentification,
  setEntityToken
} from "../../../../features/sum/sum.slice";
import SuperUserMangerActionForm, {
  Types
} from "../sum/SuperUserMangerActionForm";
import SuperUserManagerLoginForm from "../sum/SuperUserManagerLoginForm";
import EntityDetail from "../sum/EntityDetail";
import HintBlock from "../../../common/HintBlock";
import { BlockType } from "../../../../interfaces/models/Knowledge/scenario.interface";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { resetSlice } from "../../../../app/store";

export const SuperUserManagerServicesForm = ({
  setShow,
  itemData,
  parentId,
  tree,
  loading,
  createScenarioBlock,
  deleteScenarioBlock,
  changeScenarioBlock
}: {
  setShow: (item: boolean) => void;
  itemData: any;
  loading: boolean;
  createScenarioBlock: (block: any) => Promise<void>;
  deleteScenarioBlock: (block: any) => Promise<void>;
  changeScenarioBlock: (block: any) => Promise<void>;
  parentId: string | null;
  tree: any[];
}) => {
  const { t } = useTranslation();
  const currentScenarioId = useAppSelector((state) => state.bots.wizard.id);

  useEffect(() => {
    if (!itemData) {
      setIsDelete(false);
    }
  }, [itemData]);

  const entityIdentification = useSelector((state) =>
    selectSUMEntityIdentification(state, currentScenarioId)
  );

  const [showLogin, setShowLogin] = useState(false);
  const dispatch = useDispatch();
  const [submitTrigger, setSubmitTrigger] = useState(false);
  const [isDelete, setIsDelete] = useState(true);
  const [disabled, setDisabled] = useState(true);

  const deleteHandler = () => {
    deleteScenarioBlock(itemData).then((res) => {
      setShow(false);
    });
  };

  const onSubmitLogin = (values: any) => {
    const _data = {
      type: BlockType.SUMLogin,
      parent: parentId,
      email: values.user_email,
      password: values.user_password,
      title: "SUM Login",
      block_id: "SUM_BLOCK_ID"
      //notes: data.notes
    };
    createScenarioBlock(_data)
      .then((result) => {
        dispatch(loginSUM({ id: currentScenarioId, config: result?.config }));
        dispatch(setEntityToken({ id: currentScenarioId }));
      })
      .catch((err) => {
        toast.error(err?.data?.message || err.message);
      });
  };

  const onLogouEntity = () => {
    const _data = {
      type: BlockType.SUMLogout,
      id: "cd775249-6519-401e-9091-ed044526ad43"
      //notes: data.notes
    };
    deleteScenarioBlock(_data)
      .then((result) => {
        if (!!result) {
          // dispatch(SUMRTKService.util.resetApiState());
          dispatch(logoutSUM({ id: currentScenarioId }));
          localStorage.removeItem(`LB_SUM_token_${currentScenarioId}`);
          resetSlice("sumRTK");
        }
      })
      .catch((err) => {
        toast.error(err?.data?.message || err.message);
      });
  };

  const onActionAdded = (values: any, type: Types) => {
    switch (type) {
      case Types.INJECT_TEMPLATE:
        onInjectTemplate(values);
        break;
      case Types.CHECK_USER_EXISTS:
        onCheckUserExists();
        break;
      case Types.USER_CREDINTIAL:
        onUserCredential();
        break;
    }
  };
  const onInjectTemplate = (values: any) => {
    const _data = {
      type: BlockType.InjectTemplate,
      parent: parentId,
      title: "SUM Inject Template",
      block_id: "SUM_BLOCK_ID",
      additionalFields: values
      //notes: data.notes
    };
    createScenarioBlock(_data).then((result) => {
      setShow(false);
    });
  };

  const onCheckUserExists = () => {
    const _data = {
      type: BlockType.CheckUserExists,
      parent: parentId,
      title: "SUM Check user exists",
      block_id: "SUM_BLOCK_ID"
      //notes: data.notes
    };
    createScenarioBlock(_data).then(() => {
      setShow(false);
    });
  };

  const onUserCredential = () => {
    const _data = {
      type: BlockType.UserLoginForm,
      parent: parentId,
      title: "SUM User login form",
      block_id: "SUM_BLOCK_ID"
      //notes: data.notes
    };
    createScenarioBlock(_data).then(() => {
      setShow(false);
    });
  };

  const onAddActionPressed = () => {
    setSubmitTrigger((prev) => !prev);
  };
  return (
    <React.Fragment>
      <ScenarioSide size="md">
        <ScenarioHeader
          type={MacBotActionKind.ShowSuperUserManagerServices}
          onClose={() => {
            setShow?.(false);
          }}
        />

        <div className="tw-px-3 tw-py-2 tw-flex-col tw-justify-start tw-items-start tw-gap-4 tw-inline-flex tw-w-full">
          {!entityIdentification && !showLogin && (
            <>
              <Row>
                <img
                  src="https://cdn.1cdn.app/application/LOUISEBOT/25031317591465_sum_banner.png"
                  alt="discover_sum"
                  className="tw-w-full tw-h-auto"
                />
              </Row>
              <Row>
                <HintBlock texts={["SuperUserManager/affiliationLink"]} />
                {/* Add here the aff id of sum*/}
                <a
                  href="https://dashboard.super-user-manager.com/register"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://cdn.1cdn.app/application/LOUISEBOT/25031318153786_small_sum_banner.png"
                    alt="sum_account"
                    className="tw-w-full tw-h-auto"
                  />
                </a>
              </Row>
            </>
          )}

          <div className="tw-self-stretch tw-flex-col tw-justify-center tw-items-start tw-gap-2 tw-flex">
            <div className="tw-self-stretch tw-text-zinc-500 tw-text-xs tw-font-normal tw-font-['Lexend'] tw-leading-none">
              {t("SuperUserManager/SUMAccount")}
            </div>
            {!!entityIdentification ? (
              <>
                <EntityDetail onLogouEntity={onLogouEntity} />
                <SuperUserMangerActionForm
                  setDisabled={setDisabled}
                  submitTrigger={submitTrigger}
                  onActionAdded={onActionAdded}
                />
              </>
            ) : showLogin ? (
              <SuperUserManagerLoginForm
                onSubmitLogin={onSubmitLogin}
                setShowLogin={setShowLogin}
                loading={loading}
              />
            ) : (
              <div className="tw-self-stretch tw-p-4 tw-bg-white tw-rounded-lg tw-border tw-border-solid tw-border-gray-300 tw-flex-col tw-justify-start tw-items-start tw-gap-3 tw-flex">
                <div className="tw-text-gray-800 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
                  {t("SuperUserManager/connectLouiseToSUM")}
                </div>

                <div className="tw-self-stretch tw-justify-start tw-items-center tw-gap-2 md:tw-flex md:tw-inline-flex ">
                  <div className="tw-px-5 tw-py-3 tw-bg-primary tw-rounded-full tw-justify-center tw-items-center tw-flex tw-overflow-hidden">
                    <div
                      role="button"
                      onClick={() => setShowLogin(true)}
                      className="tw-text-white tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight
                      "
                    >
                      {t("SuperUserManager/loginExistingAccount")}
                    </div>
                  </div>
                  <a
                    target="_blank"
                    href="https://dashboard.super-user-manager.com/register"
                    className="tw-px-5 tw-py-3 tw-bg-white tw-rounded-full tw-shadow-sm tw-border tw-border-solid tw-border-gray-300 tw-justify-center tw-items-center tw-flex tw-overflow-hidden tw-mt-3 md:tw-mt-0"
                  >
                    <div className="tw-text-gray-700 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
                      {t("SuperUserManager/createAccount")}
                    </div>
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="tw-flex flex-row tw-justify-between tw-items-center">
          <div className="tw-flex tw-justify-start tw-items-center tw-gap-2">
            {isDelete && <DeleteButton deleteHandler={deleteHandler} />}

            {itemData?.id && (
              <NodeParentChanger tree={tree} currentId={itemData.id} />
            )}
          </div>
          <div className="tw-flex tw-justify-end">
            <Button
              onClick={onAddActionPressed}
              type="button"
              className="tw-h-11 tw-px-5 tw-py-3 tw-bg-primary tw-rounded-[99px] tw-justify-center tw-items-center tw-inline-flex"
              disabled={loading || disabled}
            >
              {loading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                t("MacBotResponseForm/btn-02")
              )}
            </Button>
          </div>
        </div>
      </ScenarioSide>
    </React.Fragment>
  );
};
